module.exports = __webpack_public_path__ + "img/组1@2x.e6873a86.png";